import { PARKINGS_PATH } from './navigation';

const indexComponent = require('./ParkingsContainer');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: PARKINGS_PATH,
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/index.js